module.exports = __webpack_public_path__ + "img/pocket-13_jp.5a571b9.jpg";